exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n/* layout contants from `layout-constants.js` */\n.tag-button_tag-button_nBLRM {\n    padding: .625rem 1rem;\n    background: hsla(55, 90%, 60%, 1);\n    border-radius: 1.375rem;\n    color: hsla(55, 90%, 95%, 1);\n    height: 2.5rem;\n}\n.tag-button_tag-button-icon_26hvC {\n    max-width: 1rem;\n    max-height: 1rem;\n}\n.tag-button_active_2stEz {\n    background: hsla(55, 90%, 65%, 1);\n}\n", ""]);

// exports
exports.locals = {
	"tag-button": "tag-button_tag-button_nBLRM",
	"tagButton": "tag-button_tag-button_nBLRM",
	"tag-button-icon": "tag-button_tag-button-icon_26hvC",
	"tagButtonIcon": "tag-button_tag-button-icon_26hvC",
	"active": "tag-button_active_2stEz"
};